module.exports = __webpack_public_path__ + "static/woyw-3-b296f8fefbecb82e51f92fa6e7f93e28.png";